import { isEqual } from 'lodash';

import { selectVisitingCardEditorValue } from '../../selectors/visitingCardEditor/visitingCardEditor';
import { MetroStationInfo, VcardStatus } from '../../typings/banners';
import { State } from '../../typings/state';
import { VisitingCardEditorState } from '../../typings/VisitingCardEditor';
import { getDefaultVCardData } from '../BannerHelpers/BannerHelpers';

export const getDefaultVisitingCardEditorData = (): VisitingCardEditorState => {
    return {
        isOpen: false,
        isShortVersionChecked: false,
        isNotShowMetroInSearchChecked: false,
        isCancelButtonDisabled: false,
        vCardStatus: VcardStatus.EDITING,
        vCardData: getDefaultVCardData(),
        vCardId: ''
    };
};

export const getVisitingCardMetroStationName = (
    geoId: number,
    metroStationId?: string,
    metroStations?: Record<number, Array<MetroStationInfo>>
): string | undefined => {
    if (metroStations && metroStations[geoId] && metroStationId) {
        const stationInfo = metroStations[geoId].find(
            (station: MetroStationInfo) => station.val === metroStationId
        );
        if (stationInfo) {
            return stationInfo.text;
        }
    }

    return undefined;
};

export const getNotNeedingUpdateVisitingCardEditorIds = (
    state: State,
    editorIds: string[]
): string[] => {
    return editorIds.reduce((acc: string[], editorId) => {
        const visitingCardEditorState = selectVisitingCardEditorValue(
            state,
            editorId
        );

        if (!isNeedToUpdateEditorVisitingCard(visitingCardEditorState)) {
            acc.push(editorId);
        }

        return acc;
    }, []);
};

export const isNeedToUpdateEditorVisitingCard = (
    visitingCardEditorState: VisitingCardEditorState
): boolean => {
    return (
        visitingCardEditorState.isOpen &&
        !isEqual(visitingCardEditorState.vCardData, getDefaultVCardData())
    );
};
